module.exports = "/src/views/donate/main/elements/shop/img/p_3.svg";